import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SEO from '../SEO';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Preserves where the user was trying to go (path + query string) so LoginPage can send
    // them back there after signing in -- without this, a payment-gateway redirect landing
    // here while logged out (e.g. a checkout tab that lost its session) drops the user at a
    // bare login screen with no way back to their success confirmation.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      {/* Defense-in-depth: these routes already require auth and are Disallow'd
          in robots.txt, but noindex ensures no accidental indexing either way. */}
      <SEO
        title="Your FinInteract Account"
        description="Manage your financial goals, transactions, and budgets on FinInteract."
        noIndex
      />
      {children}
    </>
  );
};

export default ProtectedRoute;
